import MargettsAriaHelper from '../../modules/aria';

const initAccordions = () => {
    const accordions = document.getElementsByClassName('accordion-title');

    [].forEach.call(accordions, accordion => {
        accordion.addEventListener('click', event => {
            event.preventDefault();

            let element = event.currentTarget;
            let icon = element.children[1];
            let accordionText = element.nextElementSibling;

            const expanded = MargettsAriaHelper.isExpanded(element);
            element.setAttribute('aria-expanded', ! expanded);
            accordionText.hidden = expanded;

            if (expanded) {
                icon.classList.remove('fa-minus');
                icon.classList.add('fa-plus');
            } else {
                icon.classList.remove('fa-plus');
                icon.classList.add('fa-minus');
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', initAccordions);
